/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, limit: NonNullable<unknown> }} Components_Upgrade_Plan_Modal_Warnings_Downgrade_Not_Allowed_DescriptionInputs */

const es_components_upgrade_plan_modal_warnings_downgrade_not_allowed_description = /** @type {(inputs: Components_Upgrade_Plan_Modal_Warnings_Downgrade_Not_Allowed_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu almacenamiento actual (${i?.used} MB) supera el límite del plan seleccionado (${i?.limit} MB). Para degradar, primero eliminá archivos ingeridos hasta quedar dentro del límite.`)
};

const en_components_upgrade_plan_modal_warnings_downgrade_not_allowed_description = /** @type {(inputs: Components_Upgrade_Plan_Modal_Warnings_Downgrade_Not_Allowed_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your current storage usage (${i?.used} MB) exceeds the selected plan's limit (${i?.limit} MB). To downgrade, please delete ingested files until your usage is within the target plan's limit.`)
};

/**
* | output |
* | --- |
* | "Your current storage usage ({used} MB) exceeds the selected plan's limit ({limit} MB). To downgrade, please delete ingested files until your usage is within ..." |
*
* @param {Components_Upgrade_Plan_Modal_Warnings_Downgrade_Not_Allowed_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_warnings_downgrade_not_allowed_description = /** @type {((inputs: Components_Upgrade_Plan_Modal_Warnings_Downgrade_Not_Allowed_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Warnings_Downgrade_Not_Allowed_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_warnings_downgrade_not_allowed_description(inputs)
	return en_components_upgrade_plan_modal_warnings_downgrade_not_allowed_description(inputs)
});
export { components_upgrade_plan_modal_warnings_downgrade_not_allowed_description as "components.upgrade_plan_modal.warnings.downgrade_not_allowed.description" }